import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { DatePopperPlacement } from 'coreOld/enums';

const getDropdownPlacementStyle = ({ placement }) => {
  if (placement === DatePopperPlacement.TOP) {
    return css`
      bottom: 45px;
      margin-bottom: 7px;

      &:after {
        bottom: -6px;
        border-top: 6px solid #fff;
      }

      &:before {
        bottom: -7px;
        border-top: ${({ theme }) => `7px solid ${theme.palette.neutral.lightest}`};
      }
    `;
  }

  return css`
    margin-top: 7px;

    &:after {
      top: -6px;
      border-bottom: 6px solid #fff;
    }

    &:before {
      top: -7px;
      border-bottom: ${({ theme }) => `7px solid ${theme.palette.neutral.lightest}`};
    }
  `;
};

export const iconStyle = {
  marginRight: 5,
  marginLeft: 10,
};

interface DateIntervalWrapperProps {
  children?: ReactNode;
  ref?: any;
}

export const DateIntervalWrapper = styled.div<DateIntervalWrapperProps>`
  position: relative;
`;

interface ControlProps {
  size?: string;
  children?: ReactNode;
  onClick?: any;
}

export const Control = styled.div<ControlProps>`
  align-items: center;
  background-color: hsl(0, 0%, 100%);
  border-color: ${({ theme }) => theme.palette.borderColor};
  border-radius: 0;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  cursor: default;
  display: flex;
  justify-content: space-between;
  min-height: ${({ theme, size }) => theme.inputHeight[size] || 45};
  outline: 0;
  position: relative;
  transition: all 100ms;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.palette.hover.borderColor};
    box-shadow: none;
  }
`;

interface IconWrapperProps {
  children?: ReactNode;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  margin-right: 5px;
`;

interface TextProps {
  children?: ReactNode;
}

export const Placeholder = styled.span<TextProps>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.placeholder};
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Text = styled.span<TextProps>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface DivProps {
  children?: ReactNode;
}

export const Menu = styled.div<DivProps>`
  overflow-y: auto;
  padding-bottom: 4px;
  position: relative;
  box-sizing: border-box;
  width: fit-content;
  border-right: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
`;

interface ListItemProps {
  selected?: boolean;
  children?: ReactNode;
  onClick?: any;
}

export const ListItem = styled.div<ListItemProps>`
  font-size: 12px;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.dropdownHover};
  }

  ${({ theme }) => css`
    &:hover {
      background-color: ${theme.colors.dropdownHover};
      color: ${theme.fonts.dropdownHover?.color || theme.palette.text.secondary};
      font-size: ${theme.fonts.dropdownHover?.fontSize};
      font-weight: ${theme.fonts.dropdownHover?.fontWeight};
      font-style: ${theme.fonts.dropdownHover?.fontStyle};
      text-decoration: ${theme.fonts.dropdownHover?.textDecoration};
    }
  `}

  ${({ selected, theme }) =>
    selected &&
    css`
      background-color: ${theme.colors.dropdownHover};
      color: ${theme.fonts.dropdownHover?.color || theme.palette.text.secondary};
      font-size: ${theme.fonts.dropdownHover?.fontSize};
      font-weight: ${theme.fonts.dropdownHover?.fontWeight};
      font-style: ${theme.fonts.dropdownHover?.fontStyle};
      text-decoration: ${theme.fonts.dropdownHover?.textDecoration};
    `}
`;

export const ButtonsWrapper = styled.div<DivProps>`
  clear: both;
  text-align: right;
  padding: 8px;
  border-top: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  line-height: 12px;
  vertical-align: middle;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const DateWrapper = styled.span<TextProps>`
  font-size: 12px;
  padding: 8px;
`;

export const Wrapper = styled.div<DivProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Box = styled.div<DivProps>``;

interface DropdownProps {
  isNotFittingToTheRight?: boolean;
  placement?: DatePopperPlacement;
  children?: ReactNode;
}

export const Dropdown = styled.div<DropdownProps>`
  background-color: hsl(0, 0%, 100%);
  position: absolute;
  border-radius: 4px;
  border: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  max-width: none;
  padding: 0;
  z-index: 3000;
  font-size: 15px;
  line-height: 1em;
  display: block;
  right: auto;
  display: flex;
  flex-direction: column;

  @media (min-width: 564px) {
    width: auto;
  }

  &:after,
  :before {
    position: absolute;
    display: inline-block;
    content: '';
  }

  &:after {
    left: 10px;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
  }

  &:before {
    left: 9px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
  }

  ${({ isNotFittingToTheRight }) =>
    isNotFittingToTheRight &&
    css`
      right: 30px;

      &:after {
        left: 258px;
      }

      &:before {
        left: 257px;
      }
    `}

  ${({ placement }) => getDropdownPlacementStyle({ placement })}
`;
